// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-2D-gQMFH","publlictitle":"wmf-2P1t494H","required":"wmf-3GNUDFUN","informationtitle":"wmf-29W4xUbZ","titles":"wmf-iOYSZxwn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/nonmedicaldevicesdetails/no-nmedical-devices.module.less
// module id = 619
// module chunks = 0